import agents from './agents';
import connectors from './connectors';
import httpTools from './httpTools';
import inboxes from './inboxes';
import mcpServers from './mcpServers';
import rules from './rules';

export default {
  aiAgents: agents,
  aiConnectors: connectors,
  aiHttpTools: httpTools,
  aiInboxes: inboxes,
  aiMcpServers: mcpServers,
  aiRules: rules,
};
